import { UNIFORM_API_KEY, UNIFORM_PROJECT_ID } from '@/core/constants/env';

/**
 * Returns whether Uniform CMS is configured with valid environment variables.
 * Requires both API key and project ID to be set with valid-looking values.
 */
function isUniformConfigured(): boolean {
  const hasApiKey = Boolean(
    UNIFORM_API_KEY && UNIFORM_API_KEY.trim().length > 10,
  );
  const hasProjectId = Boolean(
    UNIFORM_PROJECT_ID && UNIFORM_PROJECT_ID.trim().length > 10,
  );
  return hasApiKey && hasProjectId;
}

export default isUniformConfigured;
